<template>
    <!-- 右边主体[[ -->
    <div class="g-content g-autofixheight set">
        <!-- 账号设置 [[ -->
        <div class="account-settings" v-if="[10,20,40].includes(userInfo.authorType)">
            <div class="as-title">
                <h5 class="f-inlineblock-top as-title-con">账户设置</h5>
                <p class="f-inlineblock-middle as-title-prompt">腾讯游戏玩家创作联盟承诺所填实名认证信息仅用于认证用户身份</p>
                <p class="f-fr as-passed-prompt reject-reason" v-show="userInfo.authorType == 40 && userInfo.verifyResult">驳回原因：
                    {{userInfo.verifyResult}}</p>
                <p class="f-fr as-passed-prompt reject-reason" v-show="userInfo.authorType == 20">审核中</p>
            </div>
            <div>
                <ul class="as-inf-fill-in">
                    <li class="as-fill-in-box as-account-number-inf">
                        <h5 class="as-inf-tit">
                            <span class="ico ico-account-inf f-inlineblock-middle"></span>
                            <p class="f-inlineblock-top as-inf-tit-text">账户信息</p>
                        </h5>
                        <div class="as-fill-in-con">
                            <p class="as-name f-inlineblock-top">*账户昵称</p>
                            <div class="f-inlineblock-top fill-in-frame">
                                <input class="fill-in-con-box g-input color-gray" type="text" name="账户昵称"
                                    placeholder="请输入账户昵称" v-model="userInfo.userName" :disabled="!editMode">
                            </div>
                        </div>
                        <!-- <div class="as-fill-in-con">
                            <p class="as-name f-inlineblock-top">*QQ</p>
                            <div class="f-inlineblock-top fill-in-frame">
                                <input class="fill-in-con-box g-input color-gray"
                                       type="text" name="QQ"
                                       placeholder="请输入QQ号"
                                       v-model="userInfo.qq"
                                       disabled="true"
                                >
                            </div>
                        </div> -->
                        <div class="as-fill-in-con" v-if="userInfo.qq">
                            <p class="as-name f-inlineblock-top">*QQ</p>
                            <div class="f-inlineblock-top fill-in-frame">
                                <p class="asp-fill-in-con f-hide-col-1">{{ userInfo.qq }}</p>
                            </div>
                        </div>
                        <div class="as-fill-in-con as-weixin" v-else>
                            <p class="as-name f-inlineblock-top">*QQ</p>
                            <div class="f-inlineblock-top fill-in-frame">
                                <!-- 微信号出来后字体样色需变为#666 -->
                                <div class="as-weixin-btn">
                                    <a class="g-btn" href="javascript:;" @click="bindQQ">绑定QQ号</a>
                                </div>
                            </div>
                        </div>
                        <div class="as-fill-in-con as-weixin" v-if="userInfo.openid">
                            <p class="as-name f-inlineblock-top">微信</p>
                            <div class="f-inlineblock-top fill-in-frame">
                                <p class="asp-fill-in-con f-hide-col-1">{{ userInfo.wxName }}</p>
                            </div>
                        </div>
                        <div class="as-fill-in-con as-weixin" v-else>
                            <p class="as-name f-inlineblock-top">微信</p>
                            <div class="f-inlineblock-top fill-in-frame">
                                <!-- 微信号出来后字体样色需变为#666 -->
                                <div class="as-weixin-btn">
                                    <a class="g-btn" href="javascript:;" @click="bindWx">绑定微信号</a>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="as-fill-in-box as-works-inf">
                        <h5 class="as-inf-tit">
                            <span class="ico ico-works-inf f-inlineblock-middle"></span>
                            <p class="f-inlineblock-top as-inf-tit-text">作品信息</p>
                        </h5>

                        <div class="as-fill-in-con">
                            <span class="as-name f-inlineblock-top" style="line-height: 5rem">擅长游戏</span>
                            <game-list-box :selectedGame="true" style="display: inline-block" @gameChange="selectedGame"></game-list-box>
                        </div>

                        <div class="as-fill-in-con">
                            <create-type-box :selected.sync="userInfo.createType" :editMode="editMode"></create-type-box>
                        </div>
                        <div class="as-fill-in-con">
                            <p class="as-name f-inlineblock-top">您的作品</p>
                            <div class="f-inlineblock-top fill-in-frame">
                                <input class="fill-in-con-box g-input color-gray" type="text" name="您的作品"
                                    placeholder="请输入作品链接或上传作品附件" v-model="userInfo.works" :disabled="!editMode">

                                <div class="fill-in-file as-opus-upload" v-if="editMode">
                                    <!-- 上传后的样式是直接给予upload-image图片链接 -->
                                    <tgl-image-cloud-upload btnId='workPic' ref="imgUpload" @completed="imageUploadCompleted">
                                        <template #text>
                                            <div class="upload-text">点击上传作品附件</div>
                                            <div class="upload-text">支持jpg、png格式文件</div>
                                        </template>
                                    </tgl-image-cloud-upload>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="as-fill-in-box as-personal-inf">
                        <h5 class="as-inf-tit">
                            <span class="ico ico-business-card f-inlineblock-middle"></span>
                            <p class="f-inlineblock-top as-inf-tit-text">个人信息</p>
                        </h5>
                        <div class="as-fill-in-con">
                            <p class="as-name f-inlineblock-top">*手机号</p>
                            <div class="f-inlineblock-top fill-in-frame">
                                <input class="fill-in-con-box g-input color-gray" type="text" name="手机号"
                                    autocomplete="off" placeholder="请填写用于接收信息的手机号码" v-model="userInfo.mobile"
                                    :disabled="!editMode">
                            </div>
                        </div>
                        <div class="as-fill-in-con">
                            <p class="as-name f-inlineblock-top">*真实姓名</p>
                            <div class="f-inlineblock-top fill-in-frame">
                                <input class="fill-in-con-box g-input color-gray" type="text" name="真实姓名"
                                    autocomplete="off" placeholder="请填写您的姓名" v-model="userInfo.realUserName"
                                    :disabled="!editMode">
                            </div>
                        </div>
                        <div class="as-fill-in-con">
                            <p class="as-name f-inlineblock-top">*身份证号</p>
                            <div class="f-inlineblock-top fill-in-frame">
                                <input class="fill-in-con-box g-input color-gray" type="text" name="身份证号"
                                    autocomplete="off" placeholder="请填写您的身份证号码" v-model="userInfo.identityCard"
                                    :disabled="!editMode">
                                <p class="as-prompt">一个身份最多注册五个帐号</p>
                            </div>
                        </div>
                        <div v-if="editMode">
                            <div class="as-fill-in-con as-photo">
                                <p class="as-name f-inlineblock-top">*身份证照片</p>
                                <div class="fill-in-file">
                                    <div class="g-upload as-photo-just">
                                        <tgl-image-cloud-upload style="display: inline-block;margin-left: 0px;height: 126px"
                                            btnId='identityPic1' ref="imgUpload" @completed="imageUploadCompleted"
                                            :isIdCard="true" :cardType="1" :type="30" :userName="userInfo.realUserName"
                                            :userCard="userInfo.identityCard" :domHeight="127" :domWidth="207">
                                            <template #text>
                                                <div class='upload-text' style='color:#FD7E28;margin-top: 5px'>上传身份证人像面</div>
                                            </template>
                                        </tgl-image-cloud-upload>
                                    </div>
                                    <div class="g-upload as-photo-back identity-upload-box">
                                        <tgl-image-cloud-upload style="display: inline-block;margin-left: 0px;height: 126px"
                                            btnId='identityPic2' ref="imgUpload" @completed="imageUploadCompleted"
                                            :isIdCard="true" :cardType="2" :type="30" :userName="userInfo.realUserName"
                                            :userCard="userInfo.identityCard" :domHeight="127" :domWidth="207">
                                            <template #text>
                                                <div class='upload-text' style='color:#FD7E28;margin-top: 5px'>上传身份证国徽面</div>
                                            </template>
                                        </tgl-image-cloud-upload>
                                    </div>
                                    <div class="g-upload as-photo-hold">
                                        <tgl-image-cloud-upload style="display: inline-block;margin-left: 0px;height: 126px"
                                            btnId='identityPic3' ref="imgUpload" @completed="imageUploadCompleted"
                                            :isIdCard="true" :cardType="3" :type="30" :userName="userInfo.realUserName"
                                            :userCard="userInfo.identityCard" :domHeight="127" :domWidth="207">
                                            <template #text>
                                                <div class='upload-text' style='color:#FD7E28;margin-top: 5px'>上传手持身份证照片</div>
                                            </template>
                                        </tgl-image-cloud-upload>
                                    </div>
                                </div>
                            </div>
                            <div class="as-fill-in-con">
                                <p class="as-name">照片要求：</p>
                                <ul class="as-list">
                                    <li class="as-list-con">1、身份证照片文字信息、头像信息清晰可见、无遮挡；</li>
                                    <li class="as-list-con">2、图片内容真实有效、不得涂改或后期编辑；</li>
                                    <li class="as-list-con">3、手持身份证照片请确保手臂完整露出；</li>
                                    <li class="as-list-con">4、每张照片大小不得超过1M，支持jpg、png等多种图片格式；</li>
                                </ul>
                                <p class="as-kindly-reminder">温馨提示：请您务必完成QQ钱包的实名认证，已实名的用户才可接收TGL平台所下发的福利或费用；</p>
                                <p class="as-steps">（QQ钱包实名认证操作流程：手机QQ-QQ钱包-设置-实名认证）</p>
                                <div class="as-agreement">
                                    <!-- 选中label添加ico-checkbox-checked- -->
                                    <label class="f-inlineblock-middle ico ico-checkbox checkbox" :class="{'ico-checkbox-checked': isReadAgreement}">
                                        <input class="g-input" type="checkbox" name="" checked="isReadAgreement"
                                            v-model="isReadAgreement">
                                        <span></span>
                                    </label>
                                    <p class="f-inlineblock-top as-agreement-con" @click="isReadAgreement= !isReadAgreement">我已认真阅读并同意《腾讯游戏玩家创作联盟服务协议》《腾讯游戏玩家创作联盟实名认证协议》</p>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="as-fill-in-con as-photo">
                                <p class="as-name f-inlineblock-top">*身份证照片</p>
                                <div class="fill-in-file">
                                    <div class="f-inlineblock-top upload-photo">
                                        <img class="upload-photo-img" src="~Assets/img/pages/v4/img-1.png">
                                        <p class="up-already-upload">
                                            <span class="f-inlineblock-middle ico ico-tick-active"></span>
                                            已上传
                                        </p>
                                    </div>
                                    <div class="f-inlineblock-top upload-photo">
                                        <img class="upload-photo-img" src="~Assets/img/pages/v4/img-3.png">
                                        <p class="up-already-upload">
                                            <span class="f-inlineblock-middle ico ico-tick-active"></span>
                                            已上传
                                        </p>
                                    </div>
                                    <div class="f-inlineblock-top upload-photo">
                                        <img class="upload-photo-img" src="~Assets/img/pages/v4/img-2.png">
                                        <p class="up-already-upload">
                                            <span class="f-inlineblock-middle ico ico-tick-active"></span>
                                            已上传
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </li>
                </ul>
                <div class="bottom-btn" v-if="userInfo.authorType == 10">
                    <a class="auditing_btn g-btn" href="javascript:;" @click="submitForm()">提交审核</a>
                </div>
                <div class="bottom-btn" v-if="userInfo.authorType == 20 || userInfo.authorType == 40">

                    <a class="auditing_btn g-btn" href="javascript:;" @click="submitForm()" v-if="editMode">提交审核</a>
                    <a class="auditing_btn g-btn" href="javascript:;" @click="cancelSubmit" v-if="editMode">取消</a>
                    <a class="auditing_btn g-btn" href="javascript:;" @click="reSubmit" v-if="!editMode">重新提交</a>
                </div>
            </div>
        </div>
        <!-- 账号设置 ]] -->

        <!-- 账号设置-已通过 [[ -->

        <div class="account-settings-passed" v-if="userInfo.authorType == 30">
            <!-- <div class="account-settings-passed"> -->
            <div class="as-title f-clearfix">
                <h5 class="f-fl as-title-con">账户设置</h5>
                <p class="f-fr as-passed-prompt"><span class="f-inlineblock-top ico ico-passed"></span>您的帐户申请已审核通过</p>
            </div>
            <ul class="as-inf-fill-in">
                <li class="as-fill-in-box as-account-number-inf">
                    <h5 class="as-inf-tit">
                        <span class="ico ico-account-inf f-inlineblock-middle"></span>
                        <p class="f-inlineblock-top as-inf-tit-text">账户信息</p>
                    </h5>
                    <div class="as-fill-in-con">
                        <p class="as-name f-inlineblock-top">*账户昵称</p>
                        <div class="f-inlineblock-top fill-in-frame">
                            <p class="asp-fill-in-con f-hide-col-1">{{ userInfo.userName }}</p>
                        </div>
                        <div class="f-inlineblock-top fill-in-frame" style="
                                height: 41px;
                                vertical-align: middle;
                                display: inline-flex;
                                align-items: center;
                                margin-left: 30px
                            ">
                            <a class="g-btn" href="javascript:;" @click="syncNickname">同步账号昵称和头像</a>
                        </div>
                    </div>
                    <div class="as-fill-in-con" v-if="userInfo.qq">
                        <p class="as-name f-inlineblock-top">*QQ</p>
                        <div class="f-inlineblock-top fill-in-frame">
                            <p class="asp-fill-in-con f-hide-col-1">{{ userInfo.qq }}</p>
                        </div>
                    </div>
                    <div class="as-fill-in-con as-weixin" style="width: 662px;" v-else>
                        <p class="as-name f-inlineblock-top">*QQ</p>
                        <div class="f-inlineblock-top fill-in-frame">
                            <!-- 微信号出来后字体样色需变为#666 -->
                            <div class="as-weixin-btn">
                                <a class="g-btn" href="javascript:;" @click="bindQQ">绑定QQ号</a>
                            </div>
                        </div>
                    </div>
                    <div class="as-fill-in-con as-weixin" v-if="userInfo.openid">
                        <p class="as-name f-inlineblock-top">微信</p>
                        <div class="f-inlineblock-top fill-in-frame">
                            <p class="asp-fill-in-con f-hide-col-1">{{ userInfo.wxName }}</p>
                        </div>
                    </div>
                    <div class="as-fill-in-con as-weixin" style="width: 662px;" v-else>
                        <p class="as-name f-inlineblock-top">微信</p>
                        <div class="f-inlineblock-top fill-in-frame">
                            <!-- 微信号出来后字体样色需变为#666 -->
                            <div class="as-weixin-btn">
                                <a class="g-btn" href="javascript:;" @click="bindWx">绑定微信号</a>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="as-fill-in-box as-works-inf">
                    <h5 class="as-inf-tit">
                        <span class="ico ico-works-inf f-inlineblock-middle"></span>
                        <p class="f-inlineblock-top f-hide-col-1 as-inf-tit-text">作品信息</p>
                    </h5>
                    <div class="as-fill-in-con">
                        <p class="as-name f-inlineblock-top">擅长游戏</p>
                        <div class="f-inlineblock-top fill-in-frame">
                            <p class="asp-fill-in-con">{{ getGameName }}</p>
                        </div>
                    </div>
                    <div class="as-fill-in-con">
                        <p class="as-name f-inlineblock-top">创作类型</p>
                        <div class="f-inlineblock-top fill-in-frame">
                            <p class="asp-fill-in-con f-hide-col-1">{{ getCreateTypeName}}</p>
                        </div>
                    </div>
                    <div class="as-fill-in-con">
                        <p class="as-name f-inlineblock-top">您的作品</p>
                        <div class="f-inlineblock-top fill-in-frame">
                            <p class="asp-fill-in-con f-hide-col-1">{{ userInfo.works }}</p>
                        </div>
                    </div>
                </li>
                <li class="as-fill-in-box as-personal-inf">
                    <h5 class="as-inf-tit">
                        <span class="ico ico-business-card f-inlineblock-middle"></span>
                        <p class="f-inlineblock-top f-hide-col-1 as-inf-tit-text">个人信息</p>
                    </h5>
                    <div class="as-fill-in-con">
                        <p class="as-name f-inlineblock-top">*手机号</p>
                        <div class="f-inlineblock-top fill-in-frame">
                            <p class="asp-fill-in-con f-hide-col-1">{{ userInfo.mobile }}</p>
                        </div>
                    </div>
                    <div class="as-fill-in-con">
                        <p class="as-name f-inlineblock-top">*真实姓名</p>
                        <div class="f-inlineblock-top fill-in-frame">
                            <p class="asp-fill-in-con f-hide-col-1">{{ userInfo.realUserName }}</p>
                        </div>
                    </div>
                    <div class="as-fill-in-con">
                        <p class="as-name f-inlineblock-top">*身份证号</p>
                        <div class="f-inlineblock-top fill-in-frame">
                            <p class="asp-fill-in-con f-hide-col-1">{{ userInfo.identityCard }}</p>
                        </div>
                    </div>
                    <div class="as-fill-in-con as-photo">
                        <p class="as-name f-inlineblock-top">*身份证照片</p>
                        <div class="fill-in-file">
                            <div class="f-inlineblock-top upload-photo">
                                <img class="upload-photo-img" src="~Assets/img/pages/v4/img-1.png">
                                <p class="up-already-upload">
                                    <span class="f-inlineblock-middle ico ico-tick-active"></span>
                                    已上传
                                </p>
                            </div>
                            <div class="f-inlineblock-top upload-photo">
                                <img class="upload-photo-img" src="~Assets/img/pages/v4/img-3.png">
                                <p class="up-already-upload">
                                    <span class="f-inlineblock-middle ico ico-tick-active"></span>
                                    已上传
                                </p>
                            </div>
                            <div class="f-inlineblock-top upload-photo">
                                <img class="upload-photo-img" src="~Assets/img/pages/v4/img-2.png">
                                <p class="up-already-upload">
                                    <span class="f-inlineblock-middle ico ico-tick-active"></span>
                                    已上传
                                </p>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <!-- 账号设置-已通过 ]] -->
        <pop ref="pop"></pop>
        <bind-account-pop ref="bindAccountPop"></bind-account-pop>
    </div>
    <!-- 右边主体]] -->
</template>
<style lang="scss" scoped>
@import '~Assets/sass/pages/v4/set/set.scss';
.as-agreement-con {
    cursor: pointer;
}
.set .account-settings .upload-photo {
    position: relative;
    margin-left: 22px;
}
.set .account-settings .up-already-upload {
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 14px;
    color: #fd7e28;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    line-height: 20px;
}
.reject-reason {
    font-size: 14px;
    padding-right: 10px;
    color: red;
}
</style>

<script>
import {
    UserApplyInfo, UserApply, AllGame, UserNickName
} from 'Services/getData.js';
import gameListBox from 'Components/v4/dropdown/gamelist_v4';
import createTypeBox from 'Components/v4/dropdown/create_type';
import bindAccountPop from 'Components/v4/pop/bind_account_pop.vue';
import pop from 'Components/v4/pop/tips';
import {
    mapGetters
} from 'vuex'
export default {
    data() {
        return {
            userInfo: {
                userName: "",
                expertGame: '',
                createType: '',
                works: '',
                mobile: '',
                realUserName: '',
                verifyResult: '',
                identityCard: '',
                attachmentIds: '',
                checkbox: ''
            },
            createType: [
                {
                    name: '请选择', value: 0
                },
                {
                    name: "图文攻略性质的图片/文章内容", value: 1
                },
                {
                    name: "攻略/搞笑/解说性质的视频内容", value: 2
                },
                {
                    name: "壁纸/漫画/插画", value: 3
                },
                {
                    name: "微电影/动画片", value: 4
                },
                {
                    name: "小说类", value: 5
                },
                {
                    name: "音乐类", value: 6
                },
                {
                    name: "cos", value: 7
                },
                {
                    name: "游戏模组（MOD）", value: 8
                }
            ],
            selectedCreateType: {
                name: '请选择',
                value: '',
                hide: true
            },
            allGame: [],
            isReadAgreement: false,
            identityAttachmentIds: [],
            editMode: false,
            rejectReason: ''
        }
    },
    components: {
        gameListBox, createTypeBox, pop, bindAccountPop
    },
    computed: {
        ...mapGetters([
            'accountRejectReason'
        ]),
        getGameName() {
            let name = '';
            this.allGame.map((item) => {
                if (this.userInfo.expertGame == item.id) {
                    name = item.name;
                }
            });
            return name;
        },
        getCreateTypeName() {
            let createType = '';
            this.createType.map((item) => {
                if (this.userInfo.createType == item.value) {
                    if (this.userInfo.createType == 0) {
                        createType = '';
                    } else {
                        createType = item.name;
                    }
                }
            })
            return createType;
        }
    },
    created() {
        this.getAllGame()
    },
    mounted() {
        this.init();
        if (this.$route.query.type === 'bindqq') {
            if (!this.$route.query.bindend) {
                this.$confirm('绑定QQ', '提示', {
                    distinguishCancelAndClose: true,
                    showClose: false,
                    confirmButtonText: '绑定QQ',
                    closeOnClickModal: false
                })
                    .then(() => {
                        this.bindQQ();
                    })
                    .catch(action => {

                    });
            } else {
                this.$confirm('您的媒体认证信息已经提交审核，您可以在TGL创作内容，或者回王者视角创作/查看审核结果', '提示', {
                    distinguishCancelAndClose: true,
                    showClose: false,
                    confirmButtonText: '留下创作',
                    cancelButtonText: '回到王者视角'
                })
                    .then(() => {

                    })
                    .catch(action => {
                        location.href = '//pvp.qq.com/author/#/set/set'
                    });
            }
        }
    },
    methods: {
        async syncNickname() {
            let accessToken = this.$common.getCookie("access_token");
            let res = await UserNickName({
                accessToken: this.$common.getCookie("access_token"),
                openid: this.$common.getCookie("openid"),
                loginType: this.$common.getCookie("tglLoginType")
            })
            if (res.data.data.result) {
                this.getUserInfo();
                this.$store.dispatch({
                    type: "getUserInfo"
                });
                this.$message({
                    message: '同步成功',
                    type: 'success'
                });
            } else {
                this.$message({
                    message: '登录态失效，请重新登录后再同步昵称和头像',
                    type: 'error'
                });
            }
        },
        bindWx() {
            this.$refs.bindAccountPop.toBind('wx');
        },
        bindQQ() {
            this.$refs.bindAccountPop.toBind('qq');
        },
        init() {
            this.getUserInfo();
        },
        submitForm() {
            if (!this.validateForm()) {
                return false;
            }
            this.saveApplyData();
        },
        reSubmit() {
            this.editMode = true;
            this.userInfo.mobile = '';
            this.userInfo.realUserName = '';
            this.userInfo.identityCard = '';
            this.userInfo.works = '';
            this.userInfo.expertGame = '';
        },
        cancelSubmit() {
            this.editMode = false;
            this.getUserInfo();
        },
        async saveApplyData() {
            let param = Object.assign(this.userInfo, {
                attachmentIds: this.identityAttachmentIds.join(','), checkbox: this.isReadAgreement
            });
            let {
                userName, expertGame, createType, works, mobile, realUserName, identityCard, attachmentIds, checkbox
            } = param;
            let ret = await UserApply({
                userName, expertGame, createType, works, mobile, realUserName, identityCard, attachmentIds, checkbox
            });
            let data = ret.data;
            if (ret.status == 200 && ret.data.code == 0) {
                this.$alert('操作成功~');
                this.editMode = true;
                // this.getUserInfo();
                window.location.reload()
            }
        },
        validateForm() {
            if (!this.isReadAgreement) {
                this.$alert('请确认勾选《认证协议》和《服务协议》');
                return false;
            }
            if (!this.userInfo.qq || !/[1-9]\d{4,}/.test(this.userInfo.qq)) {
                this.$alert('请输入正确的QQ号');
                return false;
            }
            if (!this.userInfo.mobile || !/^1[3456789]\d{9}$/.test(this.userInfo.mobile)) {
                this.$alert('请输入正确的手机号');
                return false;
            }
            if (!this.userInfo.realUserName) {
                this.$alert('请输入真实姓名');
                return false;
            }
            if (/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.userInfo.identityCard) === false) {
                this.$alert("身份证输入不合法");
                return false;
            }
            return true;
        },
        async getUserInfo() {
            let res = await UserApplyInfo();
            if (res.status == 200 && res.data.code == 0) {
                this.userInfo = res.data.data;
            }
        },
        imageUploadCompleted(res) {
            if (res.btnId == 'workPic') { // 删除注意
                this.userInfo.works = res.url;
            } else if (['identityPic1', 'identityPic2', 'identityPic3'].includes(res.btnId)) {
                if (res.btnId == 'identityPic1') {
                    this.identityAttachmentIds[0] = res.id
                }
                if (res.btnId == 'identityPic2') {
                    this.identityAttachmentIds[1] = res.id
                }
                if (res.btnId == 'identityPic3') {
                    this.identityAttachmentIds[2] = res.id
                }
            }
        },
        selectedGame(gameItem) {
            if (gameItem.id) {
                this.userInfo.expertGame = gameItem.id;
            }
        },
        async getAllGame() {
            let res = await AllGame();
            if (res.status == 200 && res.data.code == 0) {
                this.allGame = res.data.data;
            }
        }
    },
}
</script>
